import { APP_ENVS } from '@savgroup-front-common/constants/shared';

export interface LatencyWeightRule {
  pattern: RegExp;
  weight: number;
  label?: string;
}

export const LATENCY_WEIGHT = {
  EXCLUDED: 0,
  NORMAL: 1,
  AMPLIFIED: 2,
} as const;

export const DEFAULT_LATENCY_WEIGHT = LATENCY_WEIGHT.NORMAL;

export const BASE_LATENCY_WEIGHT_RULES: LatencyWeightRule[] = [
  {
    pattern: /ReverseImportService\/console\/.*/,
    weight: LATENCY_WEIGHT.EXCLUDED,
    label: 'console-calls',
  },
];

export const LATENCY_WEIGHT_RULES_BY_ENV: Partial<
  Record<APP_ENVS, LatencyWeightRule[]>
> = {
  [APP_ENVS.DEV]: [],
  [APP_ENVS.DEMO]: [],
  [APP_ENVS.PROD]: [],
};
